<template>
     <!-- 视频 -->
    <div class="logindialag" v-if="modelShow">
        <div class="zhezhao" @click="modelShow = false"></div>
        <div class="loginFrom">
            <div class="loginFrom-left">
                <div class="left-title">登录</div>
                <!-- <div class="form-content"> -->
                    <el-input v-model.trim="form.loginName" placeholder="账号" @focus="errorMsg=''"></el-input>
                    <el-input type="password" @keyup.enter.native="gologin" v-model="form.password" placeholder="密码" @focus="errorMsg=''"></el-input>
                    <div class="error-msg">
                        <span v-show="errorMsg!=''">{{errorMsg}}</span>
                    </div>
                    <div class="login-btn" @click="gologin">
                         <!-- @mouseenter="btnEnter" @mouseleave="btnOut"  -->
                        <!-- <div class="btn-bgm" ref="btnBglogin"></div> -->
                        <div class="btn-text" ref="btnlogin"> 登录 </div>
                    </div>
                    <div class="forget-btn" @click="openForget">
                        忘记密码？
                    </div>
                <!-- </div> -->
            </div>
            <!-- <div class="loginFrom-right">
                <div class="right-title">帮助</div>
                <div class="creat-btn">创建账户</div>
                <div class="forget-btn">忘记密码</div>
                <div class="number-us">
                    服务热线: 400-888-7816
                </div>
            </div> -->
        </div>
        <editPwd ref="forgetModel"></editPwd>

    </div>
    <!-- <el-dialog
    title="提示"
    :visible.sync="modelShow"
    width="30%"
    :show-close="false"
    :before-close="handleClose">
        <div>

        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="modelShow = false">取 消</el-button>
            <el-button size="small" type="primary" @click="modelShow = false">确 定</el-button>
        </span>
    </el-dialog> -->
</template>
 
<script>
import Bus from "@/Bus.js"
import editPwd from "@/components/editPwd/forget"

export default {
    name: "loginModel",
    components:{
        editPwd
    },
    data() {
        return {
            modelShow:false,
            form:{
                loginName:"",
                password:"",
                loginType:'2',
            },
            btnWidth:0,
            time:null,
            errorMsg:""
        };
    },
    created(){

    },
    methods:{
        handleClose(){

        },
        gologin(){
            axios.post(`${window.$server_config.VUE_APP_WEBSITE_API }api/userInfoEntity/loginBefore`,this.form).then(response => {
                // console.log(response)
                var res=response.data
                if(res.code=== 200){
                    
                    if(res.data.userTypeEntity.type==4){
                        // this.$message({
                        //     message: '用户不存在！',
                        //     type: 'success'
                        // });
                        this.errorMsg ='用户不存在！';
                        return
                    }
                    let newObj = {
                        loginName:this.form.loginName,
                        password:this.form.password,
                        loginType:this.form.loginType,
                        merchantCode:res.data.userTypeEntity.merchantCode,
                    }


                    axios.post(`${window.$server_config.VUE_APP_WEBSITE_API }api/userInfoEntity/loginAfter`,newObj).then(response => {
                        // console.log(response)
                        var res=response.data
                        if(res.code=== 200){

                            // this.$message({
                            //     message: '欢迎回来！'+res.data.userInfoEntity.userName,
                            //     type: 'success'
                            // });

                            mercyStore.SETuserInfoEntity(res.data);
                            Bus.$emit("changeUserEntity");
                            this.modelShow = false;


                        }else{
                            this.errorMsg = res.msg?res.msg:'请求有误，请稍后重试'
                            // this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
                        }
                    })

                }else{
                    this.errorMsg = res.msg?res.msg:'请求有误，请稍后重试'
                    // this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
                }
            })

        },
        openForget(){
            this.errorMsg = "";
            this.$refs.forgetModel.editPwdShow = true;
        },
        openModel(){
            this.form.loginName="";
            this.form.password="";
            this.errorMsg = "";
            this.modelShow = true;
        },
        // btnEnter(){
        //     clearInterval(this.time) 
        //     this.$refs.btnlogin.style.color = "rgb(0 0 0)" 
        //     this.time = setInterval(()=>{
        //         this.btnWidth += 1.5
        //         this.$refs.btnBglogin.style.width = this.btnWidth + "px"
        //         if(this.btnWidth >= 352){
        //             this.$refs.btnBglogin.style.width = "352px"
        //             clearInterval(this.time) 
        //         }
        //     },1)
        // },
        // //按钮鼠标移出
        // btnOut(){
        //     clearInterval(this.time)
        //     this.$refs.btnlogin.style.color = "rgb(255,255,255)" 
        //     this.time = setInterval(()=>{
        //         this.btnWidth -= 1.5
        //         this.$refs.btnBglogin.style.width = this.btnWidth + "px"
        //         if(this.btnWidth <= 0){
        //             this.$refs.btnBglogin.style.width = "0"
        //             clearInterval(this.time) 
        //         }
        //     },1)
        // },

    },
     mounted() {
        //   this.videoClick();
        //   document.getElementById('videoId').currentTime = 0;
     },
}
</script>

<style lang="less">
    .logindialag{
        position:fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        z-index:9999;
        .zhezhao{
            width: 100%;
            height: 100%;
            opacity: 0.25;
            background: #333;
        }
        .loginFrom{
            position: absolute;
            top: calc(50% - 150px);
            left: calc(50% - 300px);
            background: #fff;
            width: 600px;
            height: 325px;
            // padding: 40px;
            padding: 40px 100px;
            .loginFrom-right,.loginFrom-left{
                display: inline-block;
                // width: 49%;
                height: 100%;
                vertical-align: bottom;
                color: #000;
            }
            .loginFrom-left{
                width: 100%;
            }
            .loginFrom-left{
                // padding-right: 40px;
                // border-right: 1px solid #b4b4b4;
                .left-title{
                    width: 100%;
                    margin-top: 0;
                    text-align: center;
                    margin-bottom: 20px;
                    font-size: 20px;
                    font-weight: bold;

                }
                .error-msg{
                    height: 20px;
                    margin-top: -10px;
                    color: #F56C6C;
                    font-size: 12px;
                }
                .el-input{
                    margin-bottom: 16px;
                    input:focus{
                        border-color: #0a0b0c !important;
                        outline-color: #0a0b0c !important;
                    }
                    input:active{
                        border-color: #0a0b0c !important;
                        outline-color: #0a0b0c !important;
                    }
                    .el-input__inner:focus{
                        border-color: #0a0b0c !important;
                    }
                }
                .login-btn{
                    position: relative;
                    .btn-bgm{
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 0;
                        height: 100%;
                        z-index: 1;
                        background: #fff;
                    }
                    .btn-text{
                        z-index: 2;
                        width: 100%;
                        height: 100%;
                        line-height: 38px;
                        text-align: center;
                        position: absolute;
                        left: 0;
                        top: 0;
                        height: 42px;
                        color: #fff;
                        background: #161616;
                    }
                    line-height: 42px;
                    text-align: center;
                    margin-top: 4px;
                    font-size: 14px;
                    cursor: pointer;
                    background: #000;
                }
                .forget-btn{
                    margin-top: 50px;
                    font-size: 14px;
                    float: right;
                    text-decoration: underline;
                    cursor: pointer;
                }
                // .login-btn{
                //     border: 1px solid #fff;
                //     width: 160px;
                //     margin-top: 20px;
                //     height: 44px;
                //     cursor: pointer;
                //     position:relative;
                // }
                // .btn-bgm{
                //     position:absolute;
                //     left:0;
                //     top:0;
                //     width:0;
                //     height:100%;
                //     background:#fff;
                //     z-index:1;
                // }
                // .btn-text{
                //     color:rgb(255,255,255);
                //     z-index: 2;
                //     width:100%;
                //     height:100%;
                //     line-height: 38px;
                //     text-align: center;
                //     position:absolute;
                //     left:0;
                //     top:0;
                // }
            }
            .loginFrom-right{
                // padding-left: 40px;
                .right-title{
                    width: 100%;
                    margin-top: 0;
                    text-align: center;
                    margin-bottom: 20px;
                    font-size: 20px;
                    font-weight: bold;
                }
                .creat-btn,.forget-btn{
                    line-height: 42px;
                    text-align: center;
                    color: #fff;
                    background: #161616;
                    margin-top: 4px;
                    margin-bottom: 16px;
                    width: 80%;
                    margin-left: 10%;
                    font-size: 14px;
                    cursor: pointer;
                }
                .number-us{
                    text-align: center;
                    margin-top: 28px;
                }
            }
        }

    }
    
</style>



// WEBPACK FOOTER //
// src/components/loginModel.vue